import styled, { keyframes } from "styled-components";

import "../../../../GlobalStyles/Font.css";

const windowIn = keyframes`
  from {
    opacity: 1;
    transition opacity 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }
  to {
    opacity: 0;
    transition opacity 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }
`;

const windowOut = keyframes`
  from {
    opacity: 1;
    transition opacity 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }
  to {
    opacity: 0;
    transition opacity 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }
`;

export const ContainerSwicher = styled.div`
  width: 358px;
  margin-top: 20px;

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
  }

  @media (min-width: 1440px) {
    width: 447px;
  }
`;

export const SwitcherContainer = styled.div`
  display: flex;
  justify-content: space-between;
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
  padding: 6px 13px;
  color: #000;
  transition: background 550ms cubic-bezier(0.61, 0, 0.51, 1),
    box-shadow 550ms cubic-bezier(0.61, 0, 0.51, 1);
  position: relative;

  &:hover {
    cursor: pointer;
    transition: 550ms cubic-bezier(0.61, 0, 0.51, 1);
  }

  @media (min-width: 744px) {
    display: flex;
    padding: 11px 18px;
  }

  @media (min-width: 1024px) {
    padding: 24px;
  }
`;

export const TextValueLangs = styled.span`
  font-family: Exo2 Medium;
  line-height: 1.35;
  font-size: 20px;
  color: #000;

  @media (min-width: 1024px) {
    font-size: 20px;
    line-height: 1.3;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    line-height: 1.3;
  }
`;

export const SwitcherValueText = styled.span`
  display: flex;
  align-items: center;
  font-size: 20px;
  font-family: Exo2 Medium;
  line-height: 1.35;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    line-height: 1.3;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    line-height: 1.3;
  }
`;

export const SwitcherContainerOption = styled.div`
  width: 358px;
  background: #fff;
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.25);
  border-radius: 0 0 20px 20px;
  position: absolute;
  top: 32px;
  left: 0;
  padding-bottom: 10px;
  z-index: 1;

  &.switcherContainer.active {
    animation: ${windowIn} 450ms cubic-bezier(0.61, 0, 0.51, 1);
  }

  &.switcherContainer:not(.active) {
    animation: ${windowOut} 350ms cubic-bezier(0.61, 0, 0.51, 1);
  }

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
    top: 56px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    top: 67px;
  }

  @media (min-width: 1440px) {
    width: 447px;
    top: 67px;
  }
`;

export const SwitcherList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const SwitcherOptionItem = styled.li`
  width: 69px;
  margin-top: 10px;

  &:last-child {
    margin-bottom: 20px;
  }
`;

export const SwitcherOptionItemButton = styled.button`
  outline: none;
  border: none;
  background: transparent;
  font-size: 20px;
  font-family: Exo2 Medium;
  line-height: 1.35;
  color: #000;
  display: flex;
  cursor: pointer;
  white-space: nowrap;
  display: inline-block;
  width: 358px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 309px;
    font-size: 24px;
    line-height: 43px;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    line-height: 1.3;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.3;
  }
`;
